import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import { TableHead } from '@mui/material'
import React from 'react'

import { levelMap } from 'app/config'
import { formatCadence } from 'app/helpers'
import { colors } from 'app/theme/colors'

import { batchTypesProgramFlow } from '../Class/Inventory/constants'
import { formatDateToLong, formatDateToMedium } from '../Journey/helpers'

export const CartDetailsTable = ({ data }) => {
  const isActiveCareOrPreschool = data?.invoice_items?.some((item) =>
    Object.values(batchTypesProgramFlow).includes(item?.product?.type)
  )

  const type = data?.type
  const items = data?.invoice_items

  if (!items) return null

  // Feature 7b — late-fee breakdown row. `late_fee_amount` is the
  // running total accrued by the daily cron; daysLate is the simple
  // derived count (₹500/day). Rendered as a footer row on the
  // preschool / active-care variant of the table only.
  const lateFeeAmount = parseFloat(data?.late_fee_amount || 0)
  const daysLate = lateFeeAmount > 0 ? Math.round(lateFeeAmount / 500) : 0

  return isActiveCareOrPreschool ? (
    <TableContainer>
      <Table>
        <TableHead
          sx={{
            backgroundColor: colors.ohTableHeaderBg,
            color: colors.ohTableHeaderText
          }}
        >
          <TableRow>
            <TableCell>Child Name</TableCell>
            <TableCell>Grade</TableCell>
            <TableCell>Batch</TableCell>
            <TableCell>Item Status</TableCell>
            <TableCell>Program Name</TableCell>
            <TableCell>Product Type</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Academic Year</TableCell>
            <TableCell>Payment Cycle</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item?.student?.user?.full_name || 'N/A'}</TableCell>
              <TableCell>{item?.student?.standard?.name || 'N/A'}</TableCell>
              <TableCell>
                {formatCadence(item?.batch?.cadence) || 'N/A'}
              </TableCell>
              <TableCell>{item?.status || 'N/A'}</TableCell>
              <TableCell>{item?.subject_name || 'N/A'}</TableCell>
              <TableCell>{item?.product?.type || 'N/A'}</TableCell>
              <TableCell>
                {formatDateToLong(item?.start_date) || 'N/A'}
              </TableCell>
              <TableCell>{formatDateToLong(item?.end_date) || 'N/A'}</TableCell>
              <TableCell>
                {item?.program_fee?.academic_year?.name || 'N/A'}
              </TableCell>
              <TableCell>{item?.payment_cycle || 'N/A'}</TableCell>
            </TableRow>
          ))}
          {lateFeeAmount > 0 ? (
            <TableRow>
              <TableCell colSpan={9} style={{ fontWeight: 'bold' }}>
                {`Late fee (${daysLate} day${
                  daysLate === 1 ? '' : 's'
                } × ₹500)`}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {`₹${lateFeeAmount.toFixed(2)}`}
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  ) : type !== 'topup' ? (
    <TableContainer>
      <Table>
        <TableHead
          sx={{
            backgroundColor: colors.ohTableHeaderBg,
            color: colors.ohTableHeaderText
          }}
        >
          <TableRow>
            <TableCell>Child Name</TableCell>
            <TableCell>Grade</TableCell>
            <TableCell>Item Status</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Enrolment Type</TableCell>
            <TableCell>Level</TableCell>
            <TableCell>Batch</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell>Price (in coins)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item?.student?.user?.full_name || 'N/A'}</TableCell>
              <TableCell>{item?.student?.standard?.name || 'N/A'}</TableCell>
              <TableCell>{item?.status || 'N/A'}</TableCell>
              <TableCell>{item?.subject_name || 'N/A'}</TableCell>
              <TableCell>{item?.product?.type || 'N/A'}</TableCell>
              <TableCell>{levelMap?.[item?.batch?.level] || 'N/A'}</TableCell>
              <TableCell>
                {formatCadence(item?.batch?.cadence) || 'N/A'}
              </TableCell>
              <TableCell>
                {formatDateToMedium(item?.start_date) || 'N/A'}
              </TableCell>
              <TableCell>
                {formatDateToMedium(item?.end_date) || 'N/A'}
              </TableCell>
              <TableCell>{item?.cost_price || 'N/A'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <TableContainer>
      <Table>
        <TableHead
          sx={{
            backgroundColor: colors.ohTableHeaderBg,
            color: colors.ohTableHeaderText
          }}
        >
          <TableRow>
            <TableCell>Item Type</TableCell>
            <TableCell>Item Status</TableCell>
            <TableCell>Price (in coins)</TableCell>
            <TableCell>Notes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.reason}</TableCell>
              <TableCell>{item.status}</TableCell>
              <TableCell>{item.cost_price}</TableCell>
              <TableCell>
                {item?.product?.description ? item.product.description : ''}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CartDetailsTable
